import React from 'react'
import { Field } from 'redux-form'
import { Textarea } from 'lp-components'
import PropTypes from 'prop-types'

const propTypes = {
  prefix: PropTypes.string,
}

function ProgramsResourcesInterestForm({ prefix = '' }) {
  return (
    <div>
      <Field
        name={`${prefix ? prefix + '.' : ''}otherText`}
        label="Tell us more about your school's interests"
        component={Textarea}
      />
    </div>
  )
}

ProgramsResourcesInterestForm.propTypes = propTypes

export default ProgramsResourcesInterestForm
